import { useSelector } from "react-redux";
import { useQuery } from "@tanstack/react-query";

import { createAxiosInstance } from "api/axiosConfig";

export const usePaginatedHomeTasks = ({ page = 1, rows = 25, searchTerm = "" }) => {

  const tenantVal =
    useSelector((state) => state.auth.user?.tenant) ||
    localStorage.getItem("kinesin-tenant");

  return useQuery({
    queryKey: ["homeTasks", tenantVal, page, rows, searchTerm],
    queryFn: async () => {
      const axiosInstance = await createAxiosInstance();
      const params = {
        page,
        rows,
      };

      if (searchTerm && searchTerm.trim()) {
        params.searchTerm = searchTerm.trim();
      }

      const response = await axiosInstance.get(`${tenantVal}/task/get/open/homepage`, {
        params
      });

      return response.data;
    },
    enabled: !!tenantVal,
    meta: { errorMessage: "Error fetching tasks" },
   
    staleTime: 1000 * 60 * 2,
    refetchOnWindowFocus: true,
  });
};
